import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../authProvider';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [sessionMessage, setSessionMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // Pruefe auf Session-Expired Parameter
    const expired = searchParams.get('expired');
    const kicked = searchParams.get('kicked');

    if (expired === 'true') {
      setSessionMessage('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
      // Entferne Parameter aus URL
      setSearchParams({});
    } else if (kicked === 'true') {
      setSessionMessage('Sie wurden abgemeldet, da sich jemand anderes mit Ihrem Account angemeldet hat.');
      // Entferne Parameter aus URL
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSessionMessage('');
    setLoading(true);

    try {
      await authService.login(username, password);
      navigate('/');
    } catch (err) {
      setError('Ungueltiger Benutzername oder Passwort');
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
  };

  const cardStyle = {
    width: '100%',
    maxWidth: '400px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    padding: '32px',
  };

  const headerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '24px',
  };

  const iconStyle = {
    fontSize: '48px',
    marginBottom: '16px',
  };

  const titleStyle = {
    fontSize: '24px',
    fontWeight: '500',
    margin: 0,
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    marginBottom: '16px',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '14px',
    fontSize: '16px',
    backgroundColor: loading ? '#90caf9' : '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: loading ? 'not-allowed' : 'pointer',
    marginTop: '8px',
  };

  const errorStyle = {
    color: '#d32f2f',
    backgroundColor: '#ffebee',
    padding: '10px',
    borderRadius: '4px',
    marginBottom: '16px',
    textAlign: 'center',
  };

  const sessionWarningStyle = {
    color: '#e65100',
    backgroundColor: '#fff3e0',
    padding: '12px',
    borderRadius: '4px',
    marginBottom: '16px',
    textAlign: 'center',
    border: '1px solid #ffb74d',
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={headerStyle}>
          <span style={iconStyle}>🔒</span>
          <h1 style={titleStyle}>Admin Panel Login</h1>
        </div>

        {sessionMessage && <div style={sessionWarningStyle}>{sessionMessage}</div>}
        {error && <div style={errorStyle}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Benutzername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
            style={inputStyle}
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={inputStyle}
            disabled={loading}
          />
          <button type="submit" style={buttonStyle} disabled={loading}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
